// Page Transition Effect
(function() {
  'use strict';

  // Don't run transitions on back/forward browser buttons
  let isBackForward = false;
  
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      // Page was loaded from cache (back/forward navigation)
      isBackForward = true;
      document.body.classList.remove('page-transitioning');
    }
  });

  // Intercept all internal link clicks
  document.addEventListener('click', function(e) {
    // Find the clicked link (handle clicks on child elements)
    let link = e.target.closest('a');
    
    if (!link) return;
    
    const href = link.getAttribute('href');
    
    // Skip if:
    // - No href
    // - External link
    // - Hash link
    // - Download link
    // - Target blank
    // - Has data-no-transition attribute
    // - Mailto/tel links
    if (!href || 
        href.startsWith('http') && !href.includes(window.location.hostname) ||
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        link.hasAttribute('download') ||
        link.target === '_blank' ||
        link.hasAttribute('data-no-transition') ||
        isBackForward) {
      return;
    }

    // Prevent default navigation
    e.preventDefault();
    
    // Add transitioning class to trigger fade out
    document.body.classList.add('page-transitioning');
    
    // Navigate after fade out completes
    setTimeout(function() {
      window.location.href = href;
    }, 300); // Match the fadeOut animation duration
  });

  // Reset isBackForward flag after a short delay
  if (isBackForward) {
    setTimeout(function() {
      isBackForward = false;
    }, 100);
  }
})();
